<template>
  <hb-basic-page :loading="loading" :subtle-loading="subtleLoading" :title="$t('tenants.management_title')" name="tenant-management">
    <v-col cols="12" md="10" offset-md="1" offset-xl="2" xl="8">
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title :class="$vuetify.breakpoint.xsOnly ? 'column justify-center' : ''" primary-title>
              <div>
                <v-avatar
                  :class="$vuetify.breakpoint.xsOnly ? 'mb-2' : 'mr-3'"
                  :color="tenant.status === 'ACTIVE' ? $randomizeColorFromString(tenant.id, 75, 70) : 'grey lighten-2'"
                  :size="$vuetify.breakpoint.xsOnly ? '68' : '40'"
                  class="tenant-avatar"
                >
                  {{ tenant.name ? tenant.name.substring(0, 2) : '' }}
                </v-avatar>
              </div>
              <div :style="$vuetify.breakpoint.xsOnly ? 'width: 100%' : ''">
                <section-header class="text-center text-sm-left">
                  {{ tenant.name }}
                </section-header>
              </div>
            </v-card-title>

            <v-card-actions :class="$vuetify.breakpoint.xsOnly ? 'flex-column' : ''">
              <v-btn
                :block="$vuetify.breakpoint.xsOnly"
                :class="$vuetify.breakpoint.xsOnly ? 'ma-1' : ''"
                :outlined="$vuetify.breakpoint.xsOnly"
                color="primary"
                text
                @click="openEditTenantDialog"
              >
                <v-icon v-if="$icons" left>edit</v-icon>
                {{ $t('tenants.edit_organization') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>

        <!--<v-col cols="12">
          <payments/>
        </v-col>-->

        <v-col cols="12">
          <tenant-teams />
        </v-col>
        <v-col cols="12" v-if="$isAdmin">
          <v-row>
            <api-keys />
          </v-row>
        </v-col>
      </v-row>
    </v-col>

    <tenant-details-dialog ref="tenantDetailsDialog" @on-dismiss="onTenantDetailsDialogDismiss" />
  </hb-basic-page>
</template>

<script>
import TenantDetailsDialog from '@/components/Tenant/TenantManagement/TenantDetailsDialog';
import tenantApi from '@/api/tenant';
import ApiKeys from '@/components/Tenant/TenantManagement/ApiKeys';
import TenantTeams from '@/components/Tenant/TenantManagement/TenantTeams';
import SectionHeader from '@/components/SectionHeader';
import Payments from '@/components/Tenant/TenantManagement/Payments';

export default {
  name: 'TenantManagementView',
  components: {
    Payments,
    SectionHeader,
    TenantTeams,
    ApiKeys,
    TenantDetailsDialog: TenantDetailsDialog,
  },
  props: {
    openModalOnMount: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      subtleLoading: false,
      tenant: {},
    };
  },
  methods: {
    openEditTenantDialog() {
      this.$refs.tenantDetailsDialog.open(this.tenant);
    },
    onTenantDetailsDialogDismiss() {
      this.getTenant();
    },
    async getTenant() {
      if (this.tenant.id) {
        this.subtleLoading = true;
      } else {
        this.loading = true;
      }
      try {
        this.tenant = await tenantApi.getCurrentTenant();
      } catch (error) {
        this.$handleApiError(error);
      }
      this.loading = false;
      this.subtleLoading = false;
    },
  },
  async mounted() {
    if (!this.$hasMatchingTenantRoles(['tenant_admin'])) {
      this.$router.replace({ name: 'access_denied' });
      return;
    }
    await this.getTenant();
    if (this.openModalOnMount) {
      this.openEditTenantDialog();
    }
  },
};
</script>

<style lang="scss">
.user-avatar {
  overflow: hidden;
}

.users-header {
  .v-list__tile {
    height: 30px;
  }
}
</style>
